var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c(_vm.currentView,{tag:"component",on:{"handleChangeView":_vm.handleChangeView},model:{value:(_vm.currentCampaign),callback:function ($$v) {_vm.currentCampaign=$$v},expression:"currentCampaign"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521db07e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/generalixwarroom/GameSetting.vue
// module id = null
// module chunks = 